export default "__VITE_PUBLIC_ASSET__933c89ea__"